import { render, staticRenderFns } from "./Screenfull.vue?vue&type=template&id=0d6403a8&scoped=true&"
import script from "./Screenfull.vue?vue&type=script&lang=js&"
export * from "./Screenfull.vue?vue&type=script&lang=js&"
import style0 from "./Screenfull.vue?vue&type=style&index=0&id=0d6403a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6403a8",
  null
  
)

export default component.exports